import { RequestType, elapsed, initFetchObservable, initXhrObservable, timeStampNow } from '@datadog/browser-core';
import { isAllowedRequestUrl } from './resource/resourceUtils';
import { startTracer } from './tracing/tracer';
import { findGraphQlConfiguration } from './resource/graphql';
var nextRequestIndex = 1;
export function startRequestCollection(lifeCycle, configuration, sessionManager, userContext, accountContext) {
  var tracer = startTracer(configuration, sessionManager, userContext, accountContext);
  trackXhr(lifeCycle, configuration, tracer);
  trackFetch(lifeCycle, configuration, tracer);
}
export function trackXhr(lifeCycle, configuration, tracer) {
  var subscription = initXhrObservable(configuration).subscribe(function (rawContext) {
    var context = rawContext;

    if (!isAllowedRequestUrl(context.url)) {
      return;
    }

    switch (context.state) {
      case 'start':
        tracer.traceXhr(context, context.xhr);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7
        /* LifeCycleEventType.REQUEST_STARTED */
        , {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;

      case 'complete':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(8
        /* LifeCycleEventType.REQUEST_COMPLETED */
        , {
          duration: context.duration,
          method: context.method,
          requestIndex: context.requestIndex,
          spanId: context.spanId,
          startClocks: context.startClocks,
          status: context.status,
          traceId: context.traceId,
          traceSampled: context.traceSampled,
          type: RequestType.XHR,
          url: context.url,
          xhr: context.xhr,
          isAborted: context.isAborted,
          handlingStack: context.handlingStack,
          requestBody: context.requestBody,
          responseBody: context.responseBody
        });
        break;
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}
export function trackFetch(lifeCycle, configuration, tracer) {
  var subscription = initFetchObservable({
    responseBodyAction: function responseBodyAction(context) {
      var _a;

      if ((_a = findGraphQlConfiguration(context.url, configuration)) === null || _a === void 0 ? void 0 : _a.trackResponseErrors) {
        return 2
        /* ResponseBodyAction.COLLECT */
        ;
      }

      return 1
      /* ResponseBodyAction.WAIT */
      ;
    }
  }).subscribe(function (rawContext) {
    var _a;

    var context = rawContext;

    if (!isAllowedRequestUrl(context.url)) {
      return;
    }

    switch (context.state) {
      case 'start':
        tracer.traceFetch(context);
        context.requestIndex = getNextRequestIndex();
        lifeCycle.notify(7
        /* LifeCycleEventType.REQUEST_STARTED */
        , {
          requestIndex: context.requestIndex,
          url: context.url
        });
        break;

      case 'resolve':
        tracer.clearTracingIfNeeded(context);
        lifeCycle.notify(8
        /* LifeCycleEventType.REQUEST_COMPLETED */
        , {
          duration: elapsed(context.startClocks.timeStamp, timeStampNow()),
          method: context.method,
          requestIndex: context.requestIndex,
          responseType: context.responseType,
          spanId: context.spanId,
          startClocks: context.startClocks,
          status: context.status,
          traceId: context.traceId,
          traceSampled: context.traceSampled,
          type: RequestType.FETCH,
          url: context.url,
          response: context.response,
          init: context.init,
          input: context.input,
          isAborted: context.isAborted,
          handlingStack: context.handlingStack,
          requestBody: (_a = context.init) === null || _a === void 0 ? void 0 : _a.body,
          responseBody: context.responseBody
        });
        break;
    }
  });
  return {
    stop: function stop() {
      return subscription.unsubscribe();
    }
  };
}

function getNextRequestIndex() {
  var result = nextRequestIndex;
  nextRequestIndex += 1;
  return result;
}